"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPercentage = void 0;
/**
 * Formats a percentage value to display with up to 3 decimal places,
 * removing trailing zeros for cleaner display.
 *
 * @param value - The numeric value to format
 * @returns Formatted percentage string (e.g., "6.5%" instead of "6.500%")
 */
const formatPercentage = (value, trim = true) => {
    if (value === null || value === undefined) {
        return 'N/A';
    }
    // Format to 3 decimal places and remove trailing zeros
    const formatted = Number(value).toFixed(3);
    if (trim) {
        const trimmed = formatted.replace(/\.?0+$/, ''); // Remove trailing zeros and decimal point if all zeros
        return `${trimmed}%`;
    }
    return `${formatted}%`;
};
exports.formatPercentage = formatPercentage;
